import styled from 'styled-components';
import { BottomCardProps, CardProps, HexagonProps } from './props';
import Color from 'color';
import { getComputedColor } from '@/utils/theme';

export const Card = styled.div<CardProps>`
  width: 140px;
  min-width: 140px;
  height: 230px;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  transition: border 0.3s;
  transition-delay: 0.3s;
  border-radius: ${({ theme }) => theme.vars.shape.borderRadius};
  animation: ${({ animate, isWinner }) =>
    animate && isWinner ? 'bounce 1.2s ease-in' : ''};
  animation-iteration-count: ${({ animate, isWinner }) =>
    animate && isWinner ? '1' : '0'};

  &::after {
    content: '';
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 0;
    width: 97%;
    border: 3px solid
      ${({ theme }) =>
        Color(getComputedColor(theme.vars.palette.text.secondary))
          .alpha(0.2)
          .toString()};
    height: 97%;
    background: ${({ theme }) =>
      `linear-gradient(180deg, ${Color(
        getComputedColor(theme.vars.palette.background.default),
      )
        .desaturate(0.2)
        .toString()}, ${Color(
        getComputedColor(theme.vars.palette.background.default),
      )
        .desaturate(0.2)
        .lighten(0.3)
        .toString()})`};
    border-radius: ${({ theme }) => theme.vars.shape.borderRadius};
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: -1;
    margin: -3px;
    border-radius: inherit;
    background: ${({ theme, isWinner, animate, color }) =>
      animate && isWinner
        ? `linear-gradient(45deg, ${Color(color)
            .desaturate(0.2)
            .toString()}, ${Color(color)
            .desaturate(0.2)
            .lighten(0.3)
            .toString()})`
        : theme.vars.palette.background.default};
    transition: background 0.3s;
    border-radius: inherit;
  }

  @media (max-width: 768px) {
    width: 77px;
    min-width: 77px;
    height: 161px;
  }

  @keyframes bounce {
    0%,
    20%,
    50%,
    80%,
    100% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(-30px);
    }
    60% {
      transform: translateY(-15px);
    }
  }
`;

export const Hexagon = styled.div<HexagonProps>`
  width: 73px;
  aspect-ratio: auto 89 / 101;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  position: absolute;
  top: 30%;
  left: 50%;
  transform: ${({ animate, isWinner }) =>
    animate
      ? isWinner
        ? 'translate(-50%, -50%) scale(1.1)'
        : 'translate(-50%, -50%)'
      : 'translate(-50%, -50%)'};
  transition: all 0.3s;
  will-change: transform;
  overflow: hidden;

  @keyframes reflexo-animacao {
    0% {
      opacity: 0;
      transform: scaleY(-1) translateY(-100%);
    }
    50% {
      opacity: 0.5;
      transform: scaleY(-1) translateY(0);
    }
    100% {
      opacity: 0;
      transform: scaleY(-1) translateY(100%);
    }
  }
  & svg {
    transition: fill 0.3s;

    & .inside {
      fill: ${({ theme }) => theme.vars.palette.background.default};
    }

    & .outside {
      fill: ${({ theme, animate, isWinner, color }) =>
        animate && isWinner
          ? color
          : theme.vars.palette.mode == 'dark'
            ? Color(getComputedColor(theme.vars.palette.background.default))
                .lighten(0.5)
                .toString()
            : Color(getComputedColor(theme.vars.palette.background.default))
                .darken(0.05)
                .toString()};
    }
  }

  @media (max-width: 768px) {
    width: 51px;
  }
`;

export const HexagonImage = styled.svg`
  width: 100%;
  z-index: 0;
`;

export const BottomCard = styled.div<BottomCardProps>`
  width: 100%;
  height: 35px;
  background-color: ${({ color }) => color};
  position: absolute;
  bottom: 0;
  left: 0;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`;

export const Profit = styled.div`
  font-size: 12px;
  font-weight: 600;
  z-index: 10;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  margin-left: -0.5px !important;
  justify-content: center;
  color: ${({ theme }) => theme.vars.palette.text.primary};

  @media (max-width: 768px) {
    font-size: 11px;
  }
`;
